import { BadgePill, MoreInfoTooltip, Widths } from '@brandfolder/react';
import React, { FunctionComponent } from 'react';

import { BrandfolderHexColors } from '@components/library/utils';
import { moreInfoLabel } from '@components/standard-messages';

const translatedResourceTypes = {
  brandfolders: bfTranslate('Brandfolder'),
  brandguides: bfTranslate('Brandguide'),
  organizations: bfTranslate('Organization'),
  portals: bfTranslate('Portal'),
};

interface ResourceLabelProps {
  resourceType: string;
}

export const ResourceLabel: FunctionComponent<ResourceLabelProps> = ({
  resourceType,
}) => (
  <span className="resource-label">
    <BadgePill
      backgroundColor={BrandfolderHexColors.DirtyMarshmallow}
      fontSize={12}
      radius={30}
    >
      {translatedResourceTypes[resourceType]?.toUpperCase()}
    </BadgePill>
    {resourceType === 'organizations' && (
      <MoreInfoTooltip
        iconLabel={moreInfoLabel}
        iconSize={13}
        id="limits-org-tooltip"
        tooltip={bfTranslate(
          'Organization level seats count towards the plan limit'
        )}
        triggerOffset={12}
        width={Widths.Small}
      />
    )}
  </span>
);
